'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_functional_compose = require('../functional/compose.js');

var toInteger = utils_functional_compose['default'](function (value) {
  return Number.isNaN(value) ? undefined : value;
}, function (value) {
  return parseInt(value, 10);
});

exports.default = toInteger;
//# sourceMappingURL=toInteger.js.map
